export default "__VITE_ASSET__CWyOH07w__"